module.exports = __webpack_public_path__ + "img/collection-diamondJewelryBudgetMedium@2x.19e8bd1.webp";